import request from '@/utils/request'

// 获取课程列表
// GET /api/frontend/course/list
// 参数:
// - categoryId: 二级分类ID (可选)
// - keyword: 关键词 (可选) 
// - maxPrice: 最高价格 (可选)
// - minPrice: 最低价格 (可选)
// - pageNum: 页码 (可选)
// - pageSize: 每页数量 (可选)
// - parentCategoryId: 一级分类ID (可选)
// 返回: {
//   code: 0,
//   data: {
//     list: [课程列表],
//     total: 总数
//   },
//   message: ""
// }
export function getCourseList(params) {
  return request({
    url: '/api/frontend/course/list',
    method: 'get',
    params
  })
}

export function getHotCourseList(params) {
  return request({
    url: '/api/frontend/home/hot-course-list',
    method: 'get',
    params
  })
}

export function getHomeCategoryTree(params) {
  return request({
    url: '/api/frontend/home/category-tree',
    method: 'get',
    params
  })
}

export function getProjectsByCourse(courseId) {
  if (courseId == null || courseId === '') {
    return Promise.reject(new Error('缺少课程ID'))
  }
  return request({
    url: `/api/frontend/home/projects-by-course/${courseId}`,
    method: 'get'
  })
}

export function getProjectDetail(projectId) {
  if (projectId == null || projectId === '') {
    return Promise.reject(new Error('缺少项目ID'))
  }
  return request({
    url: `/api/frontend/home/project/${projectId}`,
    method: 'get'
  })
}

// 课程列表项类型定义
// {
//   categoryId: 0,          // 分类ID
//   categoryName: "",       // 分类名称
//   courseName: "",         // 课程名称
//   coverImage: "",         // 封面图片
//   currentPrice: 0,        // 当前价格
//   discountEndTime: "",    // 折扣结束时间
//   discountPrice: 0,       // 折扣价格
//   id: 0,                  // 课程ID
//   isDiscount: true,       // 是否折扣
//   isHot: true,            // 是否热门
//   isPurchased: true,      // 是否已购买
//   learningMode: 0,        // 学习模式
//   learningModeName: "",   // 学习模式名称
//   salePrice: 0,           // 销售价格
//   subtitle: "",           // 副标题
//   teachers: [             // 教师列表
//     {
//       avatar: "",         // 头像
//       id: 0,              // 教师ID
//       teacherName: ""      // 教师名称
//     }
//   ],
//   viewCount: 0            // 查看次数
// }

// 获取课程详情
// GET /api/frontend/course/{id}
// 参数:
// - id: 课程ID (路径参数)
// 返回: {
//   code: 0,
//   data: {
//     categoryId: 0,
//     categoryName: "",
//     courseName: "",
//     coverImage: "",
//     currentPrice: 0,
//     discountEndTime: "",
//     discountPrice: 0,
//     id: 0,
//     isDiscount: true,
//     isHot: true,
//     isPurchased: true,
//     learningMode: 0,
//     learningModeName: "",
//     salePrice: 0,
//     subtitle: "",
//     teachers: [
//       {
//         avatar: "",
//         id: 0,
//         teacherName: ""
//       }
//     ],
//     viewCount: 0,           // 查看次数
//     salesCount: 0           // 销量
//   },
//   message: ""
// }
export function getCourseDetail(id) {
  return request({
    url: `/api/frontend/course/${id}`,
    method: 'get'
  })
}

// 查询我的兑换记录
// GET /api/frontend/redeem/my-redeems
export function getMyRedeems(params) {
  return request({
    url: '/api/frontend/redeem/my-redeems',
    method: 'get',
    params
  })
}

export function verifyRedeemCode(data) {
  const payload = data && typeof data === 'object' ? data : { code: data }
  const code = (payload && payload.code) || ''
  const password = (payload && payload.password) || ''
  return request({
    url: '/api/frontend/redeem/verify',
    method: 'post',
    params: { code, password },
    data: { code, password }
  })
}

export function redeemCode(data) {
  const payload = data && typeof data === 'object' ? data : { code: data }
  const code = (payload && payload.code) || ''
  const password = (payload && payload.password) || ''
  return request({
    url: '/api/frontend/redeem/redeem',
    method: 'post',
    params: { code, password },
    data: { code, password }
  })
}

export function getMyCourses(params) {
  return request({
    url: '/api/frontend/personal/my-courses',
    method: 'get',
    params
  })
}

export function getMyFavorites(params) {
  return request({
    url: '/api/frontend/personal/my-favorites',
    method: 'get',
    params
  })
}

export function createMyFavorite(courseId) {
  if (courseId == null || courseId === '') {
    return Promise.reject(new Error('缺少课程ID'))
  }
  return request({
    url: '/api/frontend/personal/my-favorites',
    method: 'post',
    params: { courseId },
    data: { courseId }
  })
}

export function deleteMyFavorite(id) {
  return request({
    url: `/api/frontend/personal/my-favorites/${id}`,
    method: 'delete'
  })
}

export function getStudyProgress(params) {
  return request({
    url: '/api/frontend/personal/study-progress',
    method: 'get',
    params
  })
}

export function saveStudyProgress(data) {
  return request({
    url: '/api/frontend/personal/study-progress',
    method: 'post',
    data
  })
}

export function createCourseNote(data) {
  return request({
    url: '/api/frontend/course/notes',
    method: 'post',
    data
  })
}

export function deleteCourseNote(noteId) {
  return request({
    url: `/api/frontend/course/notes/${noteId}`,
    method: 'delete'
  })
}

export function createCourseQuestion(data) {
  return request({
    url: '/api/frontend/course/questions',
    method: 'post',
    data
  })
}

export function deleteCourseQuestion(questionId) {
  return request({
    url: `/api/frontend/course/questions/${questionId}`,
    method: 'delete'
  })
}

export function getCourseCoursewares(courseId) {
  return request({
    url: `/api/frontend/course/${courseId}/coursewares`,
    method: 'get'
  })
}

export function getCourseNotes(courseId, params) {
  return request({
    url: `/api/frontend/course/${courseId}/notes`,
    method: 'get',
    params
  })
}

export function getCourseQuestions(courseId, params) {
  return request({
    url: `/api/frontend/course/${courseId}/questions`,
    method: 'get',
    params
  })
}

export function getCourseUnitsLessons(courseId) {
  return request({
    url: `/api/frontend/course/${courseId}/units-lessons`,
    method: 'get'
  })
}

export function getHomepageRecommendTeachers() {
  return request({
    url: '/api/frontend/teacher/homepage-recommend',
    method: 'get'
  })
}

export function getAdvertisementList(params) {
  return request({
    url: '/api/frontend/advertisement/list',
    method: 'get',
    params
  })
}

export function addAdvertisementView(id) {
  return request({
    url: `/api/frontend/advertisement/${id}/view`,
    method: 'post'
  })
}

export function getUnitMockPaper(unitId) {
  return request({
    url: `/api/frontend/course/unit/${unitId}/mock-paper`,
    method: 'get'
  })
}

export function getHomepageRecommendContents(params) {
  return request({
    url: '/api/frontend/content/homepage-recommend',
    method: 'get',
    params
  })
}

export function getPlatformIntro() {
  return request({
    url: '/api/frontend/content/platform-intro',
    method: 'get'
  })
}

export function getContentDetail(id) {
  return request({
    url: `/api/frontend/content/${id}`,
    method: 'get'
  })
}

export function getVideoRecommendList(params) {
  return request({
    url: '/api/frontend/video-recommend/list',
    method: 'get',
    params
  })
}

export function submitClue(data) {
  return request({
    url: '/api/frontend/clue/submit',
    method: 'post',
    data
  })
}

export function sendClueSmsCode(phone) {
  return request({
    url: '/api/frontend/clue/sms/send',
    method: 'post',
    data: { phone }
  })
}
